import { Button, MobileStepper, CircularProgress } from "@mui/material";
import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';

/**
 * WizardNavigation - Extracted navigation UI from CreateCoupon
 * Handles Back/Next buttons, progress indicator, and Save & Continue button
 */
const WizardNavigation = ({
  currentStep,
  nextStep,
  currentStepIndex,
  totalSteps,
  onBack,
  onNext,
  onSaveAndContinue,
  disableBtn,
  disableSaveBtn,
  loading,
  isDataEditing
}) => {
  return (
    <>
      {/* Main Stepper - Only show in create mode */}
      <div className="stepper" style={isDataEditing ? { display: 'none' } : { display: 'block' }}>
        <div className="stepper-control">
          <div className="button">
            <Button onClick={onBack} style={{ marginBottom: "0px" }}>
              <KeyboardArrowLeft /> BACK
            </Button>
          </div>

          <div className="next-step">
            <p>NEXT STEP</p>
            <h3>{nextStep?.title || 'Next Step'}</h3>
          </div>

          <div className="blue-btn button">
            <Button 
              onClick={onNext} 
              disabled={disableBtn || loading} 
              style={{ marginBottom: "0px" }}
            >
              {loading ? (
                <>
                  <CircularProgress size={20} style={{ color: 'white', marginRight: '8px' }} />
                </>
              ) : (
                <>
                  CONTINUE <KeyboardArrowRight />
                </>
              )}
            </Button>
          </div>
        </div>

        <MobileStepper 
          variant="progress" 
          steps={totalSteps + 2} // +2 for start and end
          position="static" 
          activeStep={currentStepIndex} 
          style={{ maxWidth: "100%" }} 
        />
      </div>

      {/* Save & Continue - Only show in edit mode */}
      <div className="save-and-continue" style={!isDataEditing ? { display: 'none' } : { display: 'flex' }}>
        <Button 
          disabled={disableSaveBtn || loading} 
          className='save-continue-btn' 
          onClick={onSaveAndContinue}
          style={{
            opacity: (disableSaveBtn || loading) ? 0.6 : 1,
            cursor: (disableSaveBtn || loading) ? 'not-allowed' : 'pointer',
            backgroundColor: (disableSaveBtn || loading) ? '#ccc' : undefined
          }}
        >
          {loading ? (
            <>
              <CircularProgress size={20} style={{ color: 'white', marginRight: '8px' }} />
            </>
          ) : (
            'SAVE & CONTINUE'
          )}
        </Button>
      </div>
    </>
  );
};

export default WizardNavigation;
